import JsBarcode from 'jsbarcode';

const BAG_NUMBER_PREFIX = 'BAG';
const TRACKING_NUMBER_PREFIX = 'SWX';

const BAG_NUMBER_LENGTH = 16;
const TRACKING_NUMBER_LENGTH = 21;

export const isBagNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    return barCode.startsWith(BAG_NUMBER_PREFIX) && barCode.length === BAG_NUMBER_LENGTH;
};

export const isTrackingNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    if(barCode.startsWith(TRACKING_NUMBER_PREFIX))
        return barCode.length === TRACKING_NUMBER_LENGTH;
    else 
        return true;
};

export const isValidBarCode = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    if(barCode.startsWith(BAG_NUMBER_PREFIX))
        return isBagNumber(barCode);
    else 
        return isTrackingNumber(barCode);
};

/**
 * 将 BOL 号渲染为 CODE128 条码 PNG data URL，供 BOL 预览/打印 HTML 内嵌图片。
 * 与 api-server PDFTextDrawUtils（ZXing CODE_128）一致。
 */
export function generateBarcodeDataUrl(value: string | undefined | null): string | null {
    const text = value?.trim();
    if (!text) {
        return null;
    }
    if (typeof document === 'undefined') {
        return null;
    }
    try {
        const canvas = document.createElement('canvas');
        JsBarcode(canvas, text, {
            format: 'CODE128',
            width: 2,
            height: 48,
            displayValue: false,
            margin: 4,
            background: '#ffffff',
            lineColor: '#000000',
        });
        return canvas.toDataURL('image/png');
    } catch {
        return null;
    }
}